import { lazy, Suspense } from 'react';

import { Loader } from '@kega/sps-elements';

const AdyenForm = lazy(() => import('./AdyenForm'));

const Payment = () => {
    return (
        <div>
            <Suspense fallback={<Loader variant="primary" />}>
                <AdyenForm />
            </Suspense>
        </div>
    )
}

export default Payment;